import { Component, inject, Input, OnInit } from '@angular/core';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BreadcrumbService } from './breadcrumb.service';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'lib-breadcrumb',
  imports: [BreadcrumbModule, CommonModule, RouterLink, TranslocoModule],
  templateUrl: './breadcrumb.html',
  styleUrl: './breadcrumb.less',
})
export class Breadcrumb implements OnInit {
  breadcrumbService: BreadcrumbService = inject(BreadcrumbService);

  breadcrumbs$ = this.breadcrumbService.breadcrumbs$;

  @Input() color = '';
  @Input() isOneColor = false;

  ngOnInit() {
    this.isOneColor = this.color != '';
    this.breadcrumbs$.subscribe();
  }
}
